<ng-container
    *ngIf="
        showLogin === true &&
        _hasValidToken !== true &&
        _service.gettingToken === true &&
        _didFirstAttempt !== true
    "
>
    <cmps-wait-status></cmps-wait-status>
</ng-container>

<ng-container
    *ngIf="
        showLogin === true &&
        _hasValidToken !== true &&
        _didFirstAttempt === true
    "
>
    <div>
        <button
            class="cmps-teamscall-auth--sign-in-button"
            (click)="_onSignInClick()"
        >
            <div>
                <!-- yes, include svg here, not through assets -->
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                >
                    <title>MS-SymbolLockup</title>
                    <rect
                        x="1"
                        y="1"
                        width="9"
                        height="9"
                        fill="#f25022"
                    />
                    <rect
                        x="1"
                        y="11"
                        width="9"
                        height="9"
                        fill="#00a4ef"
                    />
                    <rect
                        x="11"
                        y="1"
                        width="9"
                        height="9"
                        fill="#7fba00"
                    />
                    <rect
                        x="11"
                        y="11"
                        width="9"
                        height="9"
                        fill="#ffb900"
                    />
                </svg>
            </div>
            <span>{{ _i18n._11226_SIGN_IN_WITH_MICROSOFT | translate }}</span>
        </button>
    </div>
    <div>
        <span>{{
            _i18n._11227_PLEASE_ENSURE_THAT_POPUPS_ARE_NOT_BLOCKED_ | translate
        }}</span>
    </div>
</ng-container>

<ng-container *ngIf="_hasValidToken === true && _service.gettingToken !== true">
    <ng-content></ng-content>
</ng-container>
